import Cookie from 'js-cookie'
import { useNProgress } from '@vueuse/integrations/useNProgress'

const { isLoading } = useNProgress()

const headerInterceptor = (axiosInterceptor) => {
  axiosInterceptor.interceptors.request.use(
    (config) => {
      isLoading.value = true
      config.headers['Authorization'] = `Bearer ${Cookie.get('_pup_access_token')}`
      config.headers['Content-Type'] = 'application/json'
      // config.headers['Cross-Origin-Opener-Policy'] = 'unsafe-none'
      return config
    },
    (error) => {
      isLoading.value = false
      return Promise.reject(error)
    }
  )
}

export default headerInterceptor
